import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCustomers } from "src/redux/api/_customer.api";
import { customerKeys } from "./useFetchCustomers";
import { toast } from "react-toastify";
import { AxiosError } from "axios";

export const useDeleteCustomers = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCustomers,
    onSuccess: (data) => {
      if (data.message.toLowerCase() === "success") {
        toast.success("Customers Deleted Successfully!");
        queryClient.invalidateQueries({ queryKey: customerKeys.all });
      }
    },
    onError: (error: AxiosError) => {
      toast.error("Failed to Delete Customers!");
      console.error(error);
    },
  });
};
